import { useCallback, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { RegionCode } from '@shared/api-types';
import { RegionContext, persistRegion, readPersistedRegion } from './regionContext';

interface Props {
  children: ReactNode;
  initialRegion?: RegionCode;
}

export function RegionProvider({ children, initialRegion }: Props) {
  const [region, setRegionState] = useState<RegionCode>(initialRegion ?? readPersistedRegion());

  const setRegion = useCallback((next: RegionCode) => {
    persistRegion(next);
    setRegionState(next);
  }, []);

  const value = useMemo(() => ({ region, setRegion }), [region, setRegion]);
  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
}
